import { type WaterManagement } from "../vowGameLogic";

export const WATER_MANAGEMENT_CHOICES: Array<{ value: WaterManagement; label: string, shortLabel: string}> = [
  { value: "1", label: "WM1 (30-30-30-30) - Constant Full Marsh", shortLabel: "WM1"},
  { value: "2", label: "WM2 (0-10-30-30) - Spring Flooding", shortLabel: "WM2"},
  { value: "3", label: "WM3 (10-(-20)-10-20) - Strong Summer Dry-out", shortLabel: "WM3"},
  { value: "4", label: "WM4 (20-0-0-10) - Mild Summer Dry-out", shortLabel: "WM4" },
  { value: "5", label: "WM5 (30-(-20)-10-0) - Flooding & Dry-out", shortLabel: "WM5"},
];

export const WATER_MANAGEMENT_LABELS: Record<WaterManagement, string> =
  WATER_MANAGEMENT_CHOICES.reduce(
    (acc, option) => {
      acc[option.value] = option.label;
      return acc;
    },
    {} as Record<WaterManagement, string>
  );
